<template>
  <div class="tonal-post-card-header">
    <span class="card-header__title">
      {{$t('feed.analytics.tonalComment.period')}}:
      <b>{{periodName}}</b>
    </span>
    <period-range :chart-name="chartName"/>
  </div>
</template>

<script>
  // components
  import PeriodRange from "../../../../../../../../components/periodRange/PeriodRange";

  export default {
    name: "TonalHeader",
    props: {
      chartName: {
        type: String
      }
    },
    computed: {
      periodName() {
        return this.$store.getters.periodName(this.chartName, this.$i18n);
      }
    },
    components: {
      PeriodRange
    }
  };
</script>

<style>
  @import "../../../../../../../../style/cardHeaderTitle.css";
  .tonal-post-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
</style>
